/**
 * 公共仓库
 */
import { decode } from '@/utils/base64'

export default function (Vue) {
  Vue.prototype.$store = new Vue({
    data () {
      return {
        projectData: {
          title: window.ProjectTitle
        },
        // 用户信息
        userInfo: {}
      }
    },
    methods: {
      // 获取用户信息
      getUserInfo () {
        const str = decode(sessionStorage.getItem('userInfo'))
        this.userInfo = JSON.parse(str || '{}')
        console.log('个人信息：', this.userInfo)
      }
    }
  })
}
